import { httpClient } from '../http/httpClient'

export interface SupportAttendanceDay {
  date: string
  opened: number
  attended: number
  averageAttended: number
}

export interface SupportAttendanceStatsResponse {
  from: string
  to: string
  days: SupportAttendanceDay[]
  indicators: {
    opened: number
    attended: number
    averageAttended: number
    attendants: number
    openNow: number
    inProgressNow: number
  }
}

export interface SupportAttendanceStatsParams {
  from?: string
  to?: string
}

export async function getSupportAttendanceStats(
  params: SupportAttendanceStatsParams = {},
) {
  const { data } = await httpClient.get<SupportAttendanceStatsResponse>(
    '/support-requests/stats/attendance',
    { params },
  )

  return data
}
